import PaypalFastlaneUtils from './paypal-fastlane-utils';

export default function createPaypalFastlaneUtils(): PaypalFastlaneUtils {
    return new PaypalFastlaneUtils();
}
